import React, { useEffect, useRef, useState, } from 'react'

import {
    settings, getDtRowIndexNew, setDateTimeFormatGlobal, isUndNullEmpNew, sendMessageCloseCurrentWindow, getError, getProcessButtons,
    LoadingSection, getResponse, getLanguageObj, awaitDelay
} from '../../helpers/UtilsHelper';
import useAuth from '../../auth/useAuth';

import RoleAddEditDetails from './RoleAddEditDetails';
import Menu from '../main/Menu';
import Swal from 'sweetalert2';
import { RoleClass } from '../../classes/role/roleClass';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import TableIndex from '../main/TableIndex';
import { RoleService } from '../../services/roles/RoleService';

const $ = window?.$;
const { app, colors, html, icons, images, messages, labels, react, } = settings
const { sweetAlert2, } = react;
const { urls } = app?.backend;

const currentMethod = 'Roles - function';

export default function Roles({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    const dtRolesId = 'dtRoles';
    const dateTimeFormat = {
        date: languageObj?.format?.date?.f1,
        time: languageObj?.format?.time?.type,
    };
    const [role, setRole] = useState(RoleClass?.getClass());
    const [processType, setProcessType] = useState(0);
    const [dtRowIndex, setDtRowIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [process, setProcess] = useState({ showLoading: false, add: false });
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            // Initialize DataTable
            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess) return;

            // Set Listeners
            response = setQueryCode({ subMethod: currentMethod });
            if (!response?.isSuccess) return;

            // Fetch Data
            const token = auth?.account?.tokenVzLaML?.token;
            response = await RoleService.getAll({ token, subMethod: currentMethod });

            if (!response?.isSuccess || response?.isWarning) return;

            const rolesLocal = response?.result || [];
            let dtRows = [];

            if (rolesLocal?.length > 0) {
                dtRows = rolesLocal?.map((detail) => [
                    detail?.description,
                    setDateTimeFormatGlobal({
                        date: detail?.created,
                        type: dateTimeFormat?.date,
                        format: dateTimeFormat?.time,
                        addTime: false,
                        withSeconds: false,
                        subMethod
                    })?.result,
                    getProcessButtons({
                        id: detail?.id,
                        description: detail?.description,
                        detailsShow: false,
                        editShow: true,
                        editLabel: labels?.edit?.[languageObj?.id],
                        editEnabled: true,
                        deleteShow: true,
                        deleteLabel: labels?.delete?.[languageObj?.id],
                        deleteEnabled: true,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                ]);
            }

            $(`#${dtRolesId}`).DataTable().clear().rows.add(dtRows).draw(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDataTable = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtRolesId}`).DataTable({
                destroy: true,
                data: [],
                order: [[0, 'asc']],
                columns: [
                    { title: labels?.role?.[languageObj?.id], width: '80%', orderable: true, },
                    { title: labels?.created?.[languageObj?.id], width: '15%', orderable: true, },
                    { className: 'text-center', title: labels?.process?.[languageObj?.id], width: '5%', orderable: false, },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtRolesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            const tableSelector = `#${dtRolesId} tbody`;

            $(tableSelector).on('click', 'tr', 'td', async function (e) {
                const rowIndexLocal = getDtRowIndexNew({ dtId: dtRolesId, this_: this, subMethod: currentMethod })?.result;
                if (isUndNullEmpNew({ data: rowIndexLocal, subMethod: currentMethod })?.result) return;

                const methodValueLocal = e?.target?.attributes?.method?.value || '';
                const idLocal = e?.target?.attributes?.id?.value || '';
                const descriptionLocal = e?.target?.attributes?.description?.value || '';

                if (methodValueLocal === 'edit' || methodValueLocal === 'delete') {
                    roleMethods({
                        id: idLocal,
                        description: descriptionLocal,
                        rowIndex: rowIndexLocal,
                        processType: methodValueLocal === 'edit' ? 1 : -1,
                        subMethod: currentMethod,
                    });
                }
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const roleMethods = async ({
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'roleMethods';
        let response = getResponse({ type: 0 });
        try {
            setProcessType(processType);
            setDtRowIndex(rowIndex);

            if (processType === -1) {
                // DELETE logic
                let swalProperties = SwalPropertiesClass.getClass();
                const msgTextObj = {
                    one: `${messages?.areYouSureDeleteThis?.[languageObj?.id]}<br/>`,
                    two: `${labels?.role?.[languageObj?.id]}: <b>${description}</b><br/>`,
                    three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}<br/>`,
                };

                swalProperties = {
                    icon: sweetAlert2?.icons?.warning,
                    title: msgTextObj?.one,
                    html: `${msgTextObj?.two}${msgTextObj?.three}`,
                    confirmButtonColor: colors?.warningColorExp,
                    confirmButtonText: labels?.yes?.[languageObj?.id],
                    showCancelButton: true,
                    cancelButtonColor: colors?.successColorExp,
                    cancelButtonText: labels?.no?.[languageObj?.id],
                    showLoaderOnConfirm: true,
                    customClass: {
                        popup: html?.popup,
                        confirmButton: html?.buttons?.primary,
                        cancelButton: html?.buttons?.secondary,
                    },
                    didOpen: () => {
                        Swal.hideLoading();
                    },
                    allowOutsideClick: () => !Swal?.isLoading(),
                    preConfirm: async () => {
                        let preConfirmResponse = getResponse({ type: 0 });
                        try {
                            Swal.getCancelButton().hidden = true;
                            Swal.update({
                                icon: sweetAlert2?.icons?.info,
                                title: `${messages?.processing?.[languageObj?.id]}`,
                                html: `${msgTextObj?.two}`,
                                showConfirmButton: false,
                            });

                            const token = auth?.account?.tokenVzLaML?.token;
                            preConfirmResponse = await RoleService.delete({ id, token, subMethod: currentMethod });
                            if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                            $(`#${dtRolesId}`).DataTable().row(rowIndex).remove().draw(true);

                            preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}`;
                        } catch (ex) {
                            preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod, subMethod_: subMethod });
                        }
                        return preConfirmResponse;
                    }
                };
                const swalResult = await Swal?.fire({ ...swalProperties });
                if (swalResult?.isConfirmed && swalResult?.value) {
                    response = swalResult?.value;
                } else if (swalResult?.isDismissed) {
                    response = getResponse({ type: 0 });
                }
            } else if (processType === 0) {
                // ADD logic
                setProcess(prev => ({ ...prev, showLoading: true, add: true }));
                await awaitDelay({ delayTime: settings?.timers?.oneSeconds });
                setRole(RoleClass?.getClass({ userId: auth?.account?.uid, created: new Date()?.toISOString() }));
                setShowModal(true);
            } else if (processType === 1) {
                // EDIT logic
                setProcess(prev => ({ ...prev, showLoading: true }));
                const token = auth?.account?.tokenVzLaML?.token;
                response = await RoleService.getById({ id, token, subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;

                setRole(response?.result || {});
                setShowModal(true);
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, add: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => {
            isMount.current = false;
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={'settings'} process={'roles'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-12 col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.roles?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-12 col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.roles?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='card border-0 shadow-lg login-card mb-5'>
                            <LoadingSection alt='loadingSection'
                                className='overlay dark text-white'
                                height={20}
                                hidden={!process?.showLoading}
                                width={20}
                                languageId={languageObj?.id}
                                subMethod={currentMethod} />

                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div className='d-flex align-items-center'>
                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <img alt='imgRoles'
                                                style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                src={images?.roles} />
                                        </div>
                                        <div className='d-flex flex-column'>
                                            <h5 className='mb-0 font-weight-bold text-dark'>{labels?.roles?.[languageObj?.id]}</h5>
                                            <div className='mt-1'>
                                                <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={{ ...html?.badges?.micro }}>
                                                    <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <button className='btn btn-primary shadow-sm font-weight-bold px-4 btn-primary'
                                        disabled={process?.showLoading}
                                        onClick={(e) => roleMethods({ id: '', description: '', rowIndex: 0, processType: 0, subMethod: 'btnAddRole', })}
                                        data-title={labels?.add?.[languageObj?.id]}>
                                        {!process?.add ? (
                                            <i className={`${icons?.fasFa?.plusCircle} mr-1`} />
                                        ) : (
                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                        )} {labels?.add?.[languageObj?.id]}
                                    </button>
                                </div>
                            </div>

                            <div className='card-body px-4 pb-4'>
                                <TableIndex tableId={dtRolesId} languageObj={languageObj} />
                            </div>
                        </div>

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

                {showModal && (
                    <RoleAddEditDetails $={$}
                        auth={auth}
                        role={role}
                        setRole={setRole}
                        showModal={showModal}
                        setShowModal={setShowModal}
                        dtId={dtRolesId}
                        dtRowIndex={dtRowIndex}
                        setDtRowIndex={setDtRowIndex}
                        processType={processType}
                        dateTimeFormat={dateTimeFormat} />
                )}
            </div>

        </div>
    )
}